// extracted by mini-css-extract-plugin
export default {"readOnly":"Select_readOnly__CxJNT","select":"Select_select__n2p90"};